import React from 'react';

import { useBiopharmaGroupState, useBiopharmaGroupActions } from './BiopharmaGroupContext';

import Table from '../../Shared/UI/Table/components/Table';
import Thead from '../../Shared/UI/Table/components/Thead';
import Tbody from '../../Shared/UI/Table/components/Tbody';
import Tr from '../../Shared/UI/Table/components/Tr';
import Th from '../../Shared/UI/Table/components/Th';
import Td from '../../Shared/UI/Table/components/Td';
import Button from '../../Shared/UI/Button/components/Button';

import { cacheWebpages } from './restApi';

const BiopharmaGroupWebLinks = () => {
  const biopharmaGroupState = useBiopharmaGroupState();
  const { onResponse, onError } = useBiopharmaGroupActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const handleCacheWebpages = () => {
    cacheWebpages({
      onResponse,
      onError,
      body: {
        authenticityToken,
        biopharmaGroupId: biopharmaGroupState?.biopharmaGroup?.id,
      },
    });
  };

  return (
    <>
      <Button onClick={handleCacheWebpages}>
        Cache Webpages
      </Button>
      <Table>
        <Thead>
          <Tr>
            <Th>URL</Th>
            <Th>Cache Status</Th>
          </Tr>
        </Thead>
        <Tbody>
          {biopharmaGroupState?.biopharmaGroup?.weblinks?.map(weblink => (
            <Tr key={weblink.id}>
              <Td>
                <a href={weblink.url} target="_blank" rel="noopener noreferrer">{weblink.url}</a>
              </Td>
              <Td>{weblink.hasCachedPage ? 'Cached' : 'Not Cached'}</Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </>
  );
};

export default BiopharmaGroupWebLinks;
